var _rect, _polygon, _path, _polygon2, _polygon3, _path2, _polygon4, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "32px",
    height: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    x: 13,
    y: 13,
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1e88e5",
    points: "25.68,20.92 26.688,22.36 28.272,21.208 28.272,29.56 30,29.56 30,18.616 28.56,18.616"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1e88e5",
    d: "M22.943,23.745c0.625-0.574,1.013-1.37,1.013-2.249c0-1.747-1.533-3.168-3.417-3.168 c-1.602,0-2.972,1.009-3.33,2.453l1.657,0.421c0.165-0.664,0.868-1.146,1.673-1.146c0.942,0,1.709,0.646,1.709,1.44 c0,0.794-0.767,1.44-1.709,1.44h-0.997v1.728h0.997c1.081,0,1.993,0.751,1.993,1.64c0,0.904-0.866,1.64-1.931,1.64 c-0.962,0-1.784-0.61-1.914-1.418L17,26.802c0.262,1.636,1.81,2.87,3.6,2.87c2.007,0,3.64-1.511,3.64-3.368 C24.24,25.281,23.736,24.363,22.943,23.745z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fbc02d",
    points: "34,42 14,42 13,38 14,34 34,34 35,38"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#4caf50",
    points: "38,35 42,34 42,14 38,13 34,14 34,34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e88e5",
    d: "M34,14l1-4l-1-4H9C7.343,6,6,7.343,6,9v25l4,1l4-1V14H34z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#e53935",
    points: "34,34 34,42 42,34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1565c0",
    d: "M39,6h-5v8h8V9C42,7.343,40.657,6,39,6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1565c0",
    d: "M9,42h5v-8H6v5C6,40.657,7.343,42,9,42z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendarIcon);
export default __webpack_public_path__ + "static/media/google-calendar-icon.5f19e7d936e0161e29f929f3d7601ab4.svg";
export { ForwardRef as ReactComponent };